import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { BASE_URL , HEADERS} from "../../utils/constant";


const SMS_PLANS = [
  { name: "Basic", price: 2999, sms: 3000 },
  { name: "Startup", price: 4999, sms: 7000 },
  { name: "Enterprise", price: 8000, sms: 12000 },
  { name: "Enterprise Plus+", price: 10000, sms: 20000 },
];

const GST_PERCENT = 18;
const INCLUDED_USERS = 100;
const EXTRA_USER_PRICE = 5.5; 

const BASE_PLAN_FEATURES = [
  "CRM & Lead Management",
  "Ticket Management System (Internal + Customer)",
  "Customer & Sub-Customer Login",
  "Customer Ticket Creation",
  "Field Service Requests (FSR)",
  "Inventory & Stock Management",
  "Material Request & Issue Management",
  "Stock Expenditure / Usage Tracking",
  "Expense & Expenditure Management",
  "AMC (Annual Maintenance Contract) Management",
  "User & Role Management",
  "Attendance, Punch-in / Punch-out & Leave",
  "Employee & Technician Tracking",
  "Service Requests Management",
  "Advanced Reports & Analytics",
];

const BaseSubscription = () => {
  const navigate = useNavigate();
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(0);
  const [users, setUsers] = useState(INCLUDED_USERS);
  const [loading, setLoading] = useState(false);

  const selectedPlan = SMS_PLANS[selectedPlanIndex];


  const basePrice = selectedPlan.price;

  const extraUsers = users > INCLUDED_USERS ? users - INCLUDED_USERS : 0;

  const extraUserCost = extraUsers * EXTRA_USER_PRICE;

  const subtotal = basePrice + extraUserCost;

  const gstAmount = Math.round((subtotal * GST_PERCENT) / 100);

  const totalCost = Math.round(subtotal + gstAmount);




  const loadRazorpay = () =>
    new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

  const handlePayment = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please login to continue");
      navigate("/signin");
      return;
    }

    try {
      setLoading(true);
      const loaded = await loadRazorpay();
      if (!loaded) {
        toast.error("Razorpay failed to load");
        return;
      }

      const { data } = await axios.post(
        `${BASE_URL}/users/subscriptions/activate-subscription/`,
        {
          plan: selectedPlan.name,
          sms_limit: selectedPlan.sms,
          user_limit: users,
          extra_user_cost: extraUserCost,
          subtotal,
          gst: gstAmount,
          totalCost,
          billing_cycle: "yearly",
        },
        { headers: HEADERS },
      );

      new window.Razorpay({
        key: "rzp_live_SSyTAyUNyXIR2P",
        amount: data.amount,
        currency: "INR",
        name: "Field Sathi",
        description: `${selectedPlan.name} Plan`,
        order_id: data.order_id,
        handler: async (response) => {
          await axios.post(
            `${BASE_URL}/users/subscriptions/confirm-subscription/`,
            {
              payment_id: response.razorpay_payment_id,
              order_id: data.order_id,
              
              
            },
            { headers: HEADERS },
          );

          toast.success("Plan Activated Successfully");
          navigate("/dashboard");
        },
        theme: { color: "#0d6efd" },
      }).open();
    } catch (err) {
      toast.error("Payment failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      
      <div className="text-center mb-4">
        <h4 className="fw-bold">Subscription Plans</h4>
        <p className="text-muted">1 Year Validity • 100 Users Included</p>
      </div>

    
      <div className="card shadow-sm border-0 p-4 mb-4">
        <div className="row">
          <div className="col-md-6">
            <h6 className="fw-bold mb-3">Included Features</h6>
            <ul className="small">
              {BASE_PLAN_FEATURES.slice(0, 8).map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
          </div>

          <div className="col-md-6">
            <h6 className="fw-bold mb-3 invisible">.</h6>
            <ul className="small">
              {BASE_PLAN_FEATURES.slice(8).map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

    
      <div className="card shadow-sm border-0 p-4 mb-4">
        <label className="fw-semibold">
          Users (Included: {INCLUDED_USERS})
        </label>

        <div className="d-flex justify-content-between small text-muted">
          <span>{users} Users</span>
          {extraUsers > 0 && (
            <span className="text-success">+₹{extraUserCost.toFixed(2)}</span>
          )}
        </div>

        <input
          type="range"
          min={INCLUDED_USERS}
          max="5000"
          value={users}
          onChange={(e) => setUsers(+e.target.value)}
          className="form-range"
        />
      </div>

    
      <div className="row g-4 mb-5">
        {SMS_PLANS.map((plan, index) => {
          const isSelected = selectedPlanIndex === index;

          return (
            <div className="col-md-3" key={plan.name}>
              <div
                onClick={() => setSelectedPlanIndex(index)}
                className={`card h-100 border-0 position-relative ${
                  isSelected ? "shadow-lg" : "shadow-sm"
                }`}
                style={{
                  cursor: "pointer",
                  background: isSelected ? "#e7f1ff" : "#fff",
                  border: isSelected ? "2px solid #0d6efd" : "1px solid #eee",
                  transform: isSelected ? "scale(1.03)" : "scale(1)",
                  transition: "all 0.3s ease",
                }}
              >
                
                {isSelected && (
                  <span
                    className="badge bg-primary position-absolute"
                    style={{ top: "10px", right: "10px" }}
                  >
                    Selected
                  </span>
                )}

                <div className="card-body text-center">
                  <h6 className="fw-bold">{plan.name}</h6>

                  <h4
                    className={`fw-bold mt-2 ${
                      isSelected ? "text-primary" : "text-dark"
                    }`}
                  >
                    ₹{plan.price}
                  </h4>

                  <p className="small text-muted">{plan.sms} SMS / Year</p>

                  <p className="small text-muted">100 Users Included</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="card shadow border-0 rounded-3 p-4">
            <h6 className="fw-bold mb-3">Payment Summary</h6>

            <div className="small">
              <div className="d-flex justify-content-between mb-2">
                <span>Plan</span>
                <span>{selectedPlan.name}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span>Users</span>
                <span>{users}</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span>SMS</span>
                <span>{selectedPlan.sms}</span>
              </div>

              {extraUsers > 0 && (
                <div className="d-flex justify-content-between mb-2 text-success">
                  <span>Extra Users Cost</span>
                  <span>₹{extraUserCost.toFixed(2)}</span>
                </div>
              )}

              <div className="d-flex justify-content-between mb-2">
                <span>Subtotal</span>
                <span>₹{subtotal.toFixed(2)}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span>GST (18%)</span>
                <span>₹{gstAmount}</span>
              </div>
            </div>

            <hr />

            <div className="d-flex justify-content-between align-items-center">
              <div>
                <small className="text-muted">Total Payable</small>
                <h4 className="text-primary fw-bold mb-0">₹{totalCost}</h4>
              </div>

              <button
                className="btn btn-success px-4"
                onClick={handlePayment}
                disabled={loading}
              >
                {loading ? "Processing..." : "Proceed to Payment"}
              </button>
            </div>

            <div className="text-center small text-muted mt-3">
              🔒 Secure payment via Razorpay
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaseSubscription;
